import { DASHBOARD_SAVE_ALERT_DISMISSED, LocalStorage } from "@suse-o11y/local-storage";
import { useComputed } from "@suse-o11y/signal";
import React from "react";
import { z } from "zod";

import { Alert } from "~/components/alert";

import { DocLink } from "../../../components/react/docLink/DocLink";

export interface DashboardSaveAlertProps {
	className?: string;

	/**
	 * The contextual place where the alert is shown. It is used to make a local storage key to track the dismissal state.
	 */
	placement: string;
}

export const DashboardSaveAlert: React.FC<DashboardSaveAlertProps> = ({ className, placement }) => {
	const key = `${DASHBOARD_SAVE_ALERT_DISMISSED}/${placement}`;
	const dismissed = useComputed((monitor) => LocalStorage.getItem(monitor, key, z.boolean()), [key]);

	if (dismissed) {
		return null;
	}

	return (
		<Alert className={className} onClose={() => LocalStorage.setItem(key, true)}>
			You are about to make changes to the current dashboard. However, you still have to{" "}
			<strong className="font-bold">save the dashboard</strong> if you want these changes to be persistent. To learn
			more about dashboards, check{" "}
			<DocLink capture="noop" slug="ui-dashboards">
				our docs
			</DocLink>
			.
		</Alert>
	);
};
